import { getCurrentEnvironment } from './cognito'

export default function getGraphQLConfig() {
  switch (getCurrentEnvironment()) {
    case 'UAT':
      return {
        endpoint: 'https://cfkd27ncszh4jnacqavpie36qq.appsync-api.us-east-1.amazonaws.com/graphql',
        region: 'us-east-1',
        defaultAuthMode: 'userPool'
      }

    case 'DEV':
      return {
        endpoint: 'https://wt7uhqlesrf7rmnszeeifdvxyq.appsync-api.us-east-1.amazonaws.com/graphql',
        region: 'us-east-1',
        defaultAuthMode: 'userPool'
      }

    case 'PROD':
      return {
        endpoint: 'https://f77yl2l4svek5etknhhzksx6ni.appsync-api.us-east-1.amazonaws.com/graphql',
        region: 'us-east-1',
        defaultAuthMode: 'userPool'
      }

    default:
      return {
        endpoint: 'https://wt7uhqlesrf7rmnszeeifdvxyq.appsync-api.us-east-1.amazonaws.com/graphql',
        region: 'us-east-1',
        defaultAuthMode: 'userPool'
      }
  }
}
